import VueRouter from 'vue-router';
import Page404 from './shared/404/404.vue';
import { hybridRoutesFactory } from './routes/hybrid.routes';
import { rifoWebRoutesFactory } from './routes/rifo.website.routes';
import { rifoBlogRoutesFactory } from './routes/rifo.blog.routes';


export namespace RadarRouter {
    export function routerFactory(): VueRouter {
        const hybridRoutes = hybridRoutesFactory();
        const rifoRoutes = rifoWebRoutesFactory();
        const blogRoutes = rifoBlogRoutesFactory();
        return new VueRouter({
            mode: 'history',
            routes: [
                { component: Page404, path: '*' },
                { component: Page404, path: '/not/found' },
                ...hybridRoutes,
                ...rifoRoutes,
                ...blogRoutes
            ],
            scrollBehavior(to, from, savedPosition) {
                if (to.hash) {
                    return {
                        selector: to.hash
                    };
                }
                return { x: 0, y: 0 };
            }
        });
    }
}
